const BaseModule = require('../../90_utils/base/BaseModule');
const CursorZoom = require('../../70_ui/cursor-zoom/script');
const WigglePhoto = require('../../70_ui/wiggle-photo/script');

class ImageZoom extends BaseModule {

	constructor(el) {

		super(el);

		//

		this._wigglePhoto;
		this._cursor;

		this.$image;
		this.$fullImage;
		this.imageLoading;
	}

	// add/remove listeners

	_addListeners(){

		super._addListeners();

		this.$el.on('click', this._onClick.bind(this));
	}

	_removeListeners(){
		super._removeListeners();
	}

	// global listener methods

	_domReady(){

		super._domReady();

		this.$image = this.$el.find('.image--low-res');
		this.$fullImage = this.$el.find('.image--high-res');
	}

	_resize(){

	}

	// local listener methods

	_onClick(){
		this.hide();
	}

	_onContainerOver(){
		this._cursor.enable();
	}

	_onContainerOut(){
		this._cursor.disable();
	}

	//

	_enableModules(){

		// wiggle photos

		if(!this._wigglePhoto){

			let $photo = this.$el.find('.images-wrapper');
			let $doubleWrap = this.$el.find('.double-wrap');

			this._wigglePhoto = new WigglePhoto($doubleWrap, $photo, $doubleWrap, $doubleWrap);

		}
		else { this._wigglePhoto.enable(); }

		// cursor

		if(!this._cursor){

			let $cursor = this.$el.find('[data-cursor-zoom]');

			if($cursor.length){

				this.$el.on('mouseenter', this._onContainerOver.bind(this));
				this.$el.on('mouseleave', this._onContainerOut.bind(this));

				this._cursor = new CursorZoom($cursor, this.$el);
			}
			else { this._cursor.enable(); }
		}
	}

	_disableModules(){

		if(this._wigglePhoto){ this._wigglePhoto.disable(); }
		if(this._cursor){ this._cursor.disable(); }
	}

	// image loading

	_loadImages(imageURL, fullImageURL){

		this.$image.css('background-image', 'url("' + imageURL + '")');

		this.$fullImage.css('background-image', 'url("' + fullImageURL + '")');
	}

	//

	show(imageURL, fullImageURL){

		super.show();

		this.$el.addClass('is-active');
		this._enableModules();
		this._loadImages(imageURL, fullImageURL);
	}

	hide(){

		super.hide();

		this.$el.removeClass('is-active');
		this._disableModules();
	}

	//
}

module.exports = ImageZoom;


/*

class PDPZoom {

	constructor($el, $container) {

		var $this				= $(this);
		var $cursor				= $this.find('.cursor');
		var $backButton			= $this.find('.back-btn');
		var $productImages		= $this.find('.product-image');
		var $thumbnails			= $this.find('.thumbnails');
		var $swatches			= $this.find('.swatch');
		var $activeImages		= $this.find('.active-images');
		var $currentImage		= $activeImages.find('.is-active');
		var $currentImgWrapper	= $activeImages.find('.is-active .img-wrapper');
		var $zoomImage 			= null;

		// image setting

		var colorIndex			= $this.find('.swatch.is-active').index();
		var imageRatio			= 1;
		var isImageFixed		= null;
		var isVideo				= false;
		var isIsolated			= false;

		// zoom settings

		var isCursorInit		= false;
		var isZoomed			= false;
		var isZoomComplete		= false;

		var zoomFactor			= 2;
		var zoomFactorDefault 	= 2;
		var initialZoomX		= null;
		var initialZoomY		= null;
		var initialZoomXRatio	= null;
		var initialZoomYRatio	= null;
		var zoomWidthDiff		= null;
		var zoomHeightDiff		= null;
		var productImageXOffset = 0;

		var lastShiftX			= 0;
		var lastShiftY			= 0;

		// bounds

		var backBounds			= null;
		var thumbBounds			= null;

		// cursor position / size variables

		var cursorWidth			= null;
		var cursorHeight		= null;
		var cursorHWidth		= null;
		var cursorHHeight		= null;
		var cursorX				= null;
		var cursorY				= null;
		var lastCursorX			= null;
		var lastCursorY			= null;

		// visibility state

		var currentStateId		= null;
		var untoggledStateId	= null;

		// window vars

		var docWidth 			= null;
		var winWidth			= null;
		var winHeight			= null;
		var containerOffset		= null;
		var containerWidth		= null;
		var containerHeight		= null;
		var viewportHeight		= null;

		//

		if($cursor.find('svg').length){
			initCursor();
		}
		else {
			$cursor.find('.svg').on('complete', initCursor.bind($this));
		}

		zoomFactor = parseFloat($currentImage.data('zoom-factor') || zoomFactorDefault);

		// listeners

		$this.on('mousemove', onMouseMove);
		$this.on('click', onClick);

		$thumbnails.on('thumbSelected', onThumbSelected);
		$swatches.on('click', onSwatchClicked);
		$this.find('.add-cart').on('click', onAddCartClick);

		$this.find('.dd-size-selector').on('change', onAddCartClick);
		$this.find('.dd-size-selector').on('selectEnabled', onSelectEnabled);
		$this.find('.dd-size-selector').on('selectDisabled', onSelectDisabled);

		$(window).on('hashchange', onHashChange);
		$(window).on('scroll', onScroll);
		window.vent.on('windowResize', onWindowResize);

		// ajax load init events
		window.vent.on('variationLoad', function() {
			$activeImages = $this.find('.active-images');
			$currentImage = $activeImages.find('.is-active');
			$currentImgWrapper = $activeImages.find('.is-active .img-wrapper');
			$cursor = $this.find('.cursor');
			$details = $this.find('.details');
			$productImages = $this.find('.product-image');
			$thumbnails = $this.find('.thumbnails');

			isImageFixed = null;

			$this.find('.dd-size-selector').on('change', checkErrorStatus);
			$this.find('.dd-size-selector').on('selectEnabled', onSelectEnabled);
			$this.find('.dd-size-selector').on('selectDisabled', onSelectDisabled);

			if($cursor.find('svg').length){
				initCursor();
			}
			else {
				$cursor.find('.svg').on('complete', initCursor.bind($this));
			}
			onWindowResize();
		});

		window.vent.on('mainImageSwap', function() {
			$activeImages = $this.find('.active-images');
			$currentImage = $activeImages.find('.is-active');
			$currentImgWrapper = $activeImages.find('.is-active .img-wrapper');
			$thumbnails = $this.find('.thumbnails');
			onWindowResize();
		});

		if(window.Resources === 'undefined') {
			checkHash();
		}

		onWindowResize();

		//

		if($currentImage.find(".pdp-hero-player").length) {

			$currentImage.find("img").on('load', function(){
				window.requestAnimationFrame(onWindowResize);
			});

		} else {

			$currentImgWrapper.on('load', function(){
				window.requestAnimationFrame(onWindowResize);
			});
		}

	}

	// methods

	initCursor(){

		$this.addClass('loaded');
		isCursorInit	= true;

		cursorWidth		= $cursor.outerWidth();
		cursorHeight	= $cursor.outerHeight();
		cursorHWidth	= Math.round(cursorWidth/2);
		cursorHHeight	= Math.round(cursorHeight/2);

		$activeImages.on('mouseenter', onPhotoOver.bind($this));
		$activeImages.on('mouseleave', onPhotoOut.bind($this));
		$activeImages.find('li').on('click', onPhotoClick.bind($this));

		// set cursor to mouse pos

		moveCursor();
	}

	onMouseMove(e){

		cursorX = e.pageX;
		cursorY = e.pageY;

		if(isCursorInit){ moveCursor(); }
		if(isZoomed){ moveZoomedImage(); }
	}

	onClick(e){
		onWindowResize();
	}

	moveCursor(){
		TweenMax.set($cursor, {x:cursorX - cursorHWidth - productImageXOffset, y:cursorY - cursorHHeight});
	}

	onThumbSelected(e, obj){

		var $target = obj.$thumb;
		var $nextImage = $activeImages.find('li').eq($target.index());
		var $lastImage = $currentImage;

		if(!$nextImage.hasClass('is-active')){

			$activeImages.find('.is-active').removeClass('is-active');
			$nextImage.addClass('is-active');

			if(!$nextImage.find(".pdp-hero-player").length) {
				isZoomed = false;
				zoomOutCursor();
				zoomOut();
				showDetails();
			}

			$currentImage = $nextImage;
			$currentImgWrapper = $nextImage.find('.img-wrapper');

			zoomFactor = parseFloat($currentImage.data('zoom-factor') || zoomFactorDefault);

			if(currentPlayer) {
				currentPlayer.pause();
			}

			if($currentImage.find('.pdp-hero-player').length) {

				$scanContainer.addClass("hide-cursor");

				currentPlayer = $currentImage.find(".plyr-video").parent().get(0).plyr;
				$currentImage.find(".pdp-video-poster").removeClass("show");
				currentPlayer.restart();
				currentPlayer.play();
				$currentImage.find(".plyr-video").parent().get(0).addEventListener("ended", function() {
					$currentImage.find(".pdp-video-poster").addClass("show");
				});

			} else {
				$scanContainer.removeClass("hide-cursor");
			}

			if(isZoomed){
				TweenMax.set($currentImgWrapper, {transformOrigin: (initialZoomXRatio * 100) + '% ' + (initialZoomYRatio * 100) + '%', scale:zoomFactor});
				loadZoomedImage();
				moveZoomedImage();

				window.requestAnimationFrame(function(){
					TweenMax.set($lastImage, {clearProps: 'scale, x, y'});
				});
			}
		}
	}

	// swatches

	onSwatchClicked(e){

		var $swatch = $(this);

		// swap thumbs

		if ( $swatch.index() !== colorIndex ) {
			colorIndex = $swatch.index();
			$thumbnails.trigger('swapThumbs');
		}

		// swap swatches

		$swatch.siblings('.is-active').removeClass('is-active');
		$swatch.addClass('is-active');

		// change stock status

		var $error = $details.find('.row.error');

		if($swatch.data('unavailable') === true){
			toggleHeroState('no-color-stock', true);
			$error.removeClass('display-none');
		}
		else {
			toggleHeroState(untoggledStateId, true);
			$error.addClass('display-none');
		}
	}

	//

	onAddCartClick(e){
		checkErrorStatus();
	}

	onSelectEnabled(){
		toggleHeroState(untoggledStateId, true);
	}

	onSelectDisabled(){
		if(currentStateId !== 'no-size-stock'){
			untoggledStateId = currentStateId;
			toggleHeroState('no-size-stock', true);
		}
	}

	checkErrorStatus(){

		$this.find('.dd-size-selector').each(function(){

			var $sizeSelector	= $(this);
			var $errorRow		= $details.find('.error-row');

			if ( ! $sizeSelector.data('value') ) {
				$sizeSelector.addClass('error');
				$errorRow.removeClass('display-none');
			} else {
				$sizeSelector.removeClass('error');
				$errorRow.addClass('display-none');
			}

		});
	}

	// photo-related

	onPhotoClick(e){

		if(Modernizr.mq('(min-width: ' + window.SETTINGS.tabletMaxWidthUp + 'px)')){

			isZoomed = !isZoomed;

			if ( isZoomed ) {
				zoomInCursor();
				zoomOnPhoto();
				hideDetails();
			} else {
				zoomOutCursor();
				zoomOut();
				showDetails();
			}
		}
	}

	onPhotoOver(e){

		if(!$currentImage.find('.pdp-hero-player').length) {
			TweenMax.killTweensOf($cursor);
			TweenMax.to($cursor, 0.3, {opacity:1, ease:Sine.easeIn});
			TweenMax.to($cursor, 0.5, {opacity:1, delay:0.16, ease:Quint.easeOut});
		}
	}

	onPhotoOut(e){

		TweenMax.killTweensOf($cursor);
		TweenMax.to($cursor, 0.16, {opacity:0, ease:Sine.easeIn});
		TweenMax.to($cursor, 0.16, {opacity:0, delay:0.06, ease:Quint.easeOut});
	}

	// zooming

	zoomInCursor(){

		var $center		= $cursor.find('#center');
		var $horizLine	= $cursor.find('#horiz-line');
		var d			= 0.06;

		TweenMax.fromTo($center, 0.2, {transformOrigin:'50% 50%', rotation:0}, {rotation:90, delay:d, ease:Cubic.easeIn});
		TweenMax.to($center, 0.6, {rotation:90, delay:d + 0.08, ease:Quint.easeOut});

		TweenMax.fromTo($horizLine, 0.3, {transformOrigin:'50% 50%'}, {scaleX:0, ease:Quint.easeOut});
	}

	zoomOutCursor(){

		var $center		= $cursor.find('#center');
		var $horizLine	= $cursor.find('#horiz-line');
		var d			= 0.06;

		TweenMax.to($center, 0.2, {rotation:180, delay:d, ease:Cubic.easeIn});
		TweenMax.to($center, 0.6, {rotation:180, delay:d + 0.08, ease:Quint.easeOut});

		TweenMax.to($horizLine, 0.4, {scaleX:1, delay:0, ease:Quint.easeOut});
	}

	zoomOnPhoto(e){

		var photoBounds		= $currentImgWrapper.offset();
		photoBounds.width	= $currentImgWrapper.outerWidth();
		photoBounds.height	= $currentImgWrapper.outerHeight();

		initialZoomX		= cursorX;
		initialZoomY		= cursorY;
		initialZoomXRatio	= (cursorX - photoBounds.left)/containerWidth; //photoBounds.width;
		initialZoomYRatio	= (cursorY - photoBounds.top)/photoBounds.height;

		zoomFactor = parseFloat($currentImage.data('zoom-factor') || zoomFactorDefault);

		zoomWidthDiff		= photoBounds.width * zoomFactor - containerWidth;
		zoomHeightDiff		= photoBounds.height * zoomFactor - containerHeight;

		lastShiftX 			= null;
		lastShiftY 			= null;
		isZoomComplete		= false;

		removeZoomImage();

		TweenMax.killTweensOf([$currentImgWrapper, $backButton]);

		TweenMax.set($currentImgWrapper, {transformOrigin: (initialZoomXRatio * 100) + '% ' + (initialZoomYRatio * 100) + '%'});
		TweenMax.to($currentImgWrapper, 0.2, {scale:zoomFactor, force3D:true, ease:Sine.easeIn});
		TweenMax.to($currentImgWrapper, 0.3, {scale:zoomFactor, delay:0.08, ease:Quint.easeOut, onComplete:function(){
			loadZoomedImage();
			isZoomComplete = true;
		}});

		hideBackButton();
	}

	zoomOut(){

		isZoomComplete = false;
		removeZoomImage();

		TweenMax.killTweensOf([$currentImgWrapper, $currentImage, $backButton]);

		TweenMax.to($currentImgWrapper, 0.2, {scale:1, force3D:true, ease:Sine.easeIn});
		TweenMax.to($currentImgWrapper, 0.3, {scale:1, delay:0.08, ease:Quint.easeOut});

		TweenMax.to($currentImage, 0.2, {x:0, y:0, force3D:true, ease:Sine.easeIn});
		TweenMax.to($currentImage, 0.3, {x:0, y:0, delay:0.08, ease:Quint.easeOut});

		showBackButton();
	}

	loadZoomedImage(){

		var zoomImageURL = $this.find('.active-images .is-active').attr('data-zoom-image');

		if(zoomImageURL){

			removeZoomImage();

			$zoomImage = $(new Image());
			$zoomImage.addClass('img img--zoom');
			$zoomImage.css({
				opacity: 0
			});

			$zoomImage.on('load', function(){
				TweenMax.killTweensOf($zoomImage);
				TweenMax.to($zoomImage, 0.32, {opacity:1, ease:Quad.easeIn});
				TweenMax.to($zoomImage, 1, {opacity:1, delay:0.12, ease:Cubic.easeOut});
			});

			$zoomImage[0].src = zoomImageURL;
			$currentImgWrapper.append($zoomImage);
		}
	}

	removeZoomImage(){

		if($zoomImage){
			TweenMax.killTweensOf($zoomImage);
			$zoomImage.remove();
			$zoomImage = null;
		}
	}

	hideThumbnails(){

		if ( !$thumbnails.data('is-hidden') ) {
			$thumbnails.data('is-hidden', true);
			TweenMax.set($thumbnails, {opacity: 0});
		}
	}

	showThumbnails(){

		if ( $thumbnails.data('is-hidden') ) {
			$thumbnails.data('is-hidden', false);
			TweenMax.set($thumbnails, {opacity: 1});
		}
	}

	showBackButton(){

		if ( !$backButton.data('is-showing') ) {
			$backButton.data('is-showing', true);
			TweenMax.set($backButton, {x: 0});
			TweenMax.fromTo($backButton, 0.3, {display:'block', opacity:0}, {opacity:1, ease:Sine.easeIn});
			TweenMax.to($backButton, 0.4, {opacity:1, delay:0.12, ease:Quint.easeOut, onComplete:function(){
				$backButton.css('pointer-events', 'auto');
			}});
		}
	}

	hideBackButton(){

		if ( $backButton.data('is-showing') ) {
			$backButton.data('is-showing', false);
			TweenMax.to($backButton, 0.3, {opacity:0, ease:Sine.easeIn});
			TweenMax.to($backButton, 0.4, {opacity:0, delay:0.12, ease:Quint.easeOut, onComplete:function(){
				$backButton.css('pointer-events', 'none');
			}});
		}
	}

	moveZoomedImage(){

		var $movingImage 	= ($zoomImage && $zoomImage.length) ? $zoomImage : $currentImgWrapper;
		var photoBounds		= $movingImage.offset();
		photoBounds.width 	= $movingImage.outerWidth() * zoomFactor;
		photoBounds.height 	= $movingImage.outerHeight() * zoomFactor;

		photoBounds.right 	= photoBounds.left + photoBounds.width;
		photoBounds.bottom 	= photoBounds.top + photoBounds.height;

		var wanderFactorX 	= containerWidth * 0.42; //360 * (photoBounds.width / 2000);
		var wanderFactorY 	= viewportHeight * 0.42; //360 * (photoBounds.height / 2000);

		var xRatio			= 0 - (cursorX - initialZoomX) / wanderFactorX;
		var yRatio			= 0 - (cursorY - initialZoomY) / wanderFactorY;

		var xBleed			= Math.max(0, photoBounds.width - containerWidth);
		var yBleed			= Math.max(0, photoBounds.height - viewportHeight);

		//

		var newX			= xRatio * (xBleed/2);
		var newY			= yRatio * (yBleed/2);

		if(lastShiftX === null){ lastShiftX = newX; }
		if(lastShiftY === null){ lastShiftY = newY; }

		var leftBleedOff	= photoBounds.left + (newX - lastShiftX);
		var rightBleedOff	= photoBounds.right + (newX - lastShiftX);
		var topBleedOff		= photoBounds.top + (newY - lastShiftY);
		var bottomBleedOff	= photoBounds.bottom + (newY - lastShiftY);

		var headerHeight 	= 118;

		// accurate all the way from the left, 100 off from the right
		// weird compensation, figure out why

		if(!isIsolated){

			if(photoBounds.width > containerWidth){

				if ( leftBleedOff > 0 ) {
					newX -= leftBleedOff;
				}
				else if ( rightBleedOff < containerWidth ) {
					newX += containerWidth - rightBleedOff;
				}
			}
			else {
				newX = 0;
			}

			if(photoBounds.height > viewportHeight){

				if ( topBleedOff > headerHeight ) {
					newY -= (topBleedOff - headerHeight);
				}
				else if ( bottomBleedOff < viewportHeight + headerHeight ) {
					newY += (viewportHeight + headerHeight) - bottomBleedOff;
				}
			}
			else {
				newY = 0;
			}
		}

		TweenMax.set($currentImage, {
			x: newX,
			y: newY
		});

		lastShiftX = newX;
		lastShiftY = newY;
	}

	//

	showDetails(){

		var detailsWidth	= $details.outerWidth();
		var detailsHeight	= $details.outerHeight();

		//

		TweenMax.killTweensOf([$detailsContent, $details]);
		TweenMax.to($detailsContent, 0.4, {opacity:1, ease:Cubic.easeOut});

		TweenMax.fromTo($details, 0.12, {visibility:'visible'}, {opacity:1, ease:Sine.easeIn});
		TweenMax.to($details, 0.16, {opacity:1, delay:0.08, ease:Quint.easeOut, clearProps:'all'});
	}

	hideDetails(){

		var detailsContentWidth	= $detailsContent.outerWidth();
		var detailsWidth		= $details.outerWidth();
		var detailsHeight		= $details.outerHeight();

		//

		TweenMax.killTweensOf([$detailsContent, $details]);
		TweenMax.set($detailsContent, {width: detailsContentWidth});
		TweenMax.to($detailsContent, 0.4, {opacity:0, ease:Cubic.easeOut});

		TweenMax.fromTo($details, 0.2, {opacity:1, visibility:'visible', overflow:'hidden'}, {opacity:0, ease:Sine.easeIn});
		TweenMax.to($details, 0.24, {opacity:0, delay:0.08, ease:Quint.easeOut, onComplete:function(){
			TweenMax.set($details, {
				visibility: 'hidden',
				clearProps: 'clip'
			});
		}});
	}

	//

	updateContainerVars(){

		var isDesktop = Modernizr.mq('(min-width: ' + window.SETTINGS.tabletMaxWidthUp + 'px)');

		containerOffset	= $this.offset();
		containerWidth	= $this.outerWidth();
		containerHeight	= $this.outerHeight();

		thumbBounds	= window.utils.PositioningUtils.getExtendedOffset($thumbnails);
		backBounds	= window.utils.PositioningUtils.getExtendedOffset($backButton);

		viewportWidth = isDesktop ? $details.offset().left - thumbBounds.right : docWidth;
		viewportHeight = isDesktop ? Math.min(winHeight, containerHeight) - 100 : $productImages.outerHeight();
	}

	onHashChange(){
		checkHash();
	}

	onWindowResize(){

		var isDesktop = Modernizr.mq('(min-width: ' + window.SETTINGS.tabletMaxWidthUp + 'px)');

		docWidth 	= $('body').width();
		winWidth	= window.innerWidth;
		winHeight	= window.innerHeight;

		productImageXOffset = Math.max(Math.round((docWidth - 1920)/2), 0);

		if($currentImage.find(".pdp-hero-player")) {
			productImageXOffset = Math.max(Math.round((docWidth - 1920)/2), 0);
		}

		updateContainerVars();

		TweenMax.set($backButton, {left: productImageXOffset + 40});

		if(!isZoomed && isDesktop){
			showBackButton();
		}
		else {
			hideBackButton();
		}

		if ( $currentImage && $currentImage.length ) {

			isVideo = $currentImage.find('.pdp-hero-player').length;
			isIsolated = ($currentImage.attr('data-isolated') == 'true');

			var detailsOffset = window.utils.PositioningUtils.getExtendedOffset($details);
			var backBottom = parseInt($backButton.css('top')) + backBounds.height;
			var thumbOffset = backBottom + Math.round((viewportHeight - 40 - backBottom - thumbBounds.height)/2) + 20;
			var layoutXOffset = Math.max(0, Math.round((docWidth - containerWidth)/2));

			thumbBounds.right += 40;
			detailsOffset.left -= 40;

			if(!isDesktop){
				thumbOffset = Math.round(($productImages.outerHeight() - thumbBounds.height)/2);
			}

			var thumbRoom = viewportHeight - backBottom - 40;
			var thumbScale = Math.min(1, thumbRoom / thumbBounds.height);

			TweenMax.set($thumbnails, {
				top: thumbOffset,
				scale: thumbScale,
				transformOrigin: '50% 50%'
			});

			if($currentImage.attr('data-image-width') && $currentImage.attr('data-image-height')){
				imageRatio	= parseInt($currentImage.data('image-width')) / parseInt($currentImage.data('image-height'));
			}
			else {
				imageRatio = 1;
			}

			// center image

			if ( isDesktop || isVideo ) {

				resizeImage()

			} else {

				// var leftOffset = Math.round((winWidth - $currentImgWrapper.outerWidth())/2);

				var leftOffset = Math.round($currentImage.outerWidth() * 0.12);
				var topOffset = 0;

				if(isIsolated){
					leftOffset = Math.round((winWidth - $currentImgWrapper.outerWidth() - thumbBounds.right)/2) + thumbBounds.right;
					$currentImgWrapper.css({
						'width': '',
						'height': '',
						'margin-left': leftOffset,
						'margin-top': topOffset
					});
				}
				else {
					window.utils.PositioningUtils.sizeToFit($currentImgWrapper, imageRatio, containerWidth, viewportHeight, false, false, true);
					leftOffset = 0;
					$currentImgWrapper.css({
						'margin-left': leftOffset
					});
				}
			}

			resizeImage(){

				var navOffset 		= 118;

				if(isVideo){

					if(isIsolated){
						window.utils.PositioningUtils.sizeToFit($currentImage, imageRatio, viewportWidth, viewportHeight, true, true, false);
					}
					else {
						window.utils.PositioningUtils.sizeToFit($currentImage, imageRatio, containerWidth, viewportHeight, true, false, true);
					}
				}
				else {

					if(isIsolated){
						window.utils.PositioningUtils.sizeToFit($currentImgWrapper, imageRatio, viewportWidth, viewportHeight - navOffset - 40, true, true, false);
					}
					else {
						window.utils.PositioningUtils.sizeToFit($currentImgWrapper, imageRatio, containerWidth, viewportHeight, true, false, true);
					}
				}

				var photoBounds		= $currentImgWrapper.offset();
				photoBounds.width	= $currentImgWrapper.outerWidth();
				photoBounds.height	= $currentImgWrapper.outerHeight();

				zoomWidthDiff		= photoBounds.width * zoomFactor - containerWidth;
				zoomHeightDiff		= photoBounds.height * zoomFactor - containerHeight;

				var leftOffset		= 0;
				var topOffset		= navOffset + 40;

				if(isDesktop){

					if(isIsolated){
						leftOffset 	= Math.round((detailsOffset.left - thumbBounds.right - photoBounds.width)/2 + thumbBounds.right) - layoutXOffset;
						topOffset	+= Math.max(0, Math.round((viewportHeight - navOffset - 40 - photoBounds.height)/2));
					} else {
						leftOffset	= Math.round((winWidth - photoBounds.width)*((detailsOffset.left / 2) / winWidth));
						leftOffset 	= Math.min(leftOffset, 0);
						topOffset 	= navOffset - (navOffset - 100)
					}
				}

				if(!isVideo){

					$currentImgWrapper.css({
						'margin-left': leftOffset,
						'margin-top' : topOffset
					});
				}
			}

			//

			onScroll();
		}

		if ( !isDesktop ) {
			$detailsContent.css({
				'width': '',
				'min-height': ''
			});
		}

		//

		$detailsContent.css('min-height', '');

		window.requestAnimationFrame(function(){
			$detailsContent.css('min-height', $details.outerHeight());
			window.vent.trigger('domUpdate', {$scanContainer: $this});
		});
	}

	onScroll(){

		var scrollTop = $(window).scrollTop();

		if ( Modernizr.mq('(min-width: ' + window.SETTINGS.tabletMaxWidthUp + 'px)') ) {

			thumbBounds	= window.utils.PositioningUtils.getExtendedOffset($thumbnails);
			backBounds	= window.utils.PositioningUtils.getExtendedOffset($backButton);

			if ( containerOffset.top + containerHeight < scrollTop + winHeight ) {

				if ( isImageFixed || isImageFixed === null ) {

					var bottomOffset = Math.min(0, winHeight - containerHeight);

					$productImages.css({
						position: 'absolute',
						top: 'auto',
						bottom: bottomOffset,
						width: '',
						left: ''
					});

					isImageFixed = false;
				}

				if ( !isZoomed ) {

					if ( thumbBounds && backBounds && thumbBounds.top < backBounds.top + $backButton.outerHeight() + 40 ) {
						hideBackButton();
					} else {
						showBackButton();
					}
				}
			} else {

				if ( ! isImageFixed ) {

					if(docWidth > 1920){

						$productImages.css({
							width: 1920,
							left: productImageXOffset
						});
					}
					else {

						productImageXOffset = 0;

						$productImages.css({
							width: '',
							left: ''
						});
					}

					$productImages.css({
						position: 'fixed',
						top: '0px',
						bottom: 'auto'
					});
					isImageFixed = true;

					showThumbnails();
					showBackButton();
				}
			}
		} else {

			$productImages.css({
				position: '',
				top: '',
				bottom: '',
				width: '',
				left: ''
			});

			isImageFixed = false;
		}
	}
}

*/
